// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3ViWT","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2DSrH"};